module.exports = __webpack_public_path__ + "img/55.7bad9cc2.png";